import styled from 'styled-components';

import { Vertical } from 'atoms/layout/flex';
import { DisplayS, LabelM } from 'atoms/typography';
import { Img } from 'atoms/ui/Img';
import { useIsTabletAndAbove } from 'hooks/device/useIsTabletAndAbove';
import { tabletAndAbove } from 'style/mediaQuery';

import { Pictures } from '../types';

const MainImg = styled(Img)`
  grid-area: 1 / 1 / 3 / 3;
`;

const TitleImg = styled(Img)`
  grid-area: 2 / 1 / 3 / 2;
  height: 60px;
  width: auto;
`;

const Illu = styled.picture`
  display: block;
  max-width: 100%;
  height: var(--blockHeight);
  grid-area: 1 / 1 / 3 / 2;
  object-fit: contain;
`;

const Container = styled(Vertical)`
  flex-direction: column-reverse;
  justify-content: flex-end;

  @media ${tabletAndAbove} {
    flex-direction: column;
  }
`;

const StepContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;
  min-width: 184px;
`;

const Title = styled(DisplayS)`
  font-family: var(--rigid-square);
  text-transform: uppercase;
  color: var(--c-white);
  grid-row-start: 1;
  grid-column-start: 1;
  align-self: end;
`;

export type StepByStepProps = {
  img: Pictures & {
    height: number;
    width: number;
  };
  titleImg: Pictures & {
    height: number;
    width: number;
  };
  title: string;
  subtitle: string;
};

export const StepByStep = ({
  img,
  titleImg,
  title,
  subtitle,
}: StepByStepProps) => {
  const isTabletAndAbove = useIsTabletAndAbove();
  return (
    <Container center={isTabletAndAbove} gap={isTabletAndAbove ? 4 : 2}>
      <Illu>
        <source srcSet={img.avif} type="image/avif" />
        <MainImg
          src={img.pictureUrl}
          fetchpriority="low"
          height={img.height}
          width={img.width}
        />
      </Illu>
      <StepContainer>
        <Illu>
          <source srcSet={titleImg.avif} type="image/avif" />
          <TitleImg
            src={titleImg.pictureUrl}
            fetchpriority="low"
            height={titleImg.height}
            width={titleImg.width}
          />
        </Illu>
        <Title>{title}</Title>
        <LabelM>{subtitle}</LabelM>
      </StepContainer>
    </Container>
  );
};
